import { Colors } from "@/constants/Colors"
import { Text, View } from "react-native"
import Svg, { Circle } from "react-native-svg"

type ProgressRingProps = {
  value: number
  size?: number
  strokeWidth?: number
  color?: string
  label?: string
  centerText?: string
}

export function ProgressRing({
  value,
  size = 104,
  strokeWidth = 10,
  color = Colors.dark.primary,
  label,
  centerText,
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const progress = Math.max(0, Math.min(value, 100))
  const strokeDashoffset = circumference - (progress / 100) * circumference

  return (
    <View style={{ width: size, height: size }} className="items-center justify-center">
      <Svg width={size} height={size} className="absolute">
        <Circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={Colors.dark.surfaceTertiary}
          strokeWidth={strokeWidth}
          fill="transparent"
        />
        <Circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
        />
      </Svg>
      <Text
        className="font-bold text-white"
        style={{ fontSize: size > 128 ? 34 : size > 96 ? 28 : 20 }}
      >
        {centerText ?? `${progress}%`}
      </Text>
      {label ? (
        <Text className="text-xs" style={{ color: Colors.dark.textSecondary }}>
          {label}
        </Text>
      ) : null}
    </View>
  )
}
